import { AUTH_TOKEN } from "constants/AuthConstant"
import fetch from "auth/FetchInterceptor"

const DoctorService = {
  banAccount: (id, reason) => {
    return fetch({
      data: {
        argument: reason,
      },
      method: "post",
      url: `/doctorOffice/bannedAccount/${id}`,
    })
  },
  createDoctor: (data) => {
    return fetch({
      data: data,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "post",
      url: "/doctorOffice/create",
    })
  },
  deleteDoctorById: (id) => {
    return fetch({
      method: "delete",
      url: `/doctorOffice/deleteById/${id}`,
    })
  },

  getAllDoctors: (page) => {
    return fetch({
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "get",
      url: `/admin/doctors/subscriptions?page=${page}&limit=10`,
    })
  },
  getDoctorById: (id) => {
    return fetch({
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "get",
      url: `/doctorOffice/getById/${id}`,
    })
  },
  getSearchDoctors: (value, page) => {
    return fetch({
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
      },
      method: "get",
      url: `/doctorOffice/getAll?page=${page}&companyName=${value}&limit=10`,
    })
  },
  updateDoctorById: (id, data) => {
    return fetch({
      data: data,
      method: "put",
      url: `/doctorOffice/updateById/${id}`,
    })
  },

  validateAccount: (id) => {
    return fetch({
      method: "post",
      url: `/doctorOffice/validateAccount/${id}`,
    })
  },
}

export default DoctorService
